import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useOrg } from '../contexts/OrgContext';

export default function RequireOrg() {
  const { activeOrg, loading } = useOrg();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!activeOrg) {
    return <Navigate to="/org" replace />;
  }

  return <Outlet />;
}
